// API_URL is processed during the frontend build. It contains first part of path - typically /api
declare const API_URL: string;

/**
 * Get rapidoc endpoint with fragment to operationId
 */
export const getDocsUrlForTableEndpoint = (path: string): string => {
  const url = `${API_URL}/rapidoc/`;
  return path === undefined ? url : `${url}#post-${path}`;
};
